//PASO 2
import { useState } from 'react';
import { addUserApi, getMeApi, getUsersApi, userEditApi, userDeleteApi } from '../api/user'
import {useAuth} from '.'
export  function useUser() {

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [users, setUsers] = useState(null)
    const {auth} = useAuth();

    //PASO 1
    const getMe = async (token) => {
    try {
       const response = await getMeApi(token);
       return response;
        
    } catch (error) {
        throw error;
    }
    }

    const getUsers = async () => {
      try {

        setLoading(true);
        const response = await getUsersApi(auth.token);
        setLoading(false);
        setUsers(response);

      } catch (error) {        
        setLoading(false);
        setError(error);
        console.log(error)

      }
    }

    const addUser = async (data) => {
      try {
        setLoading(true);
        await addUserApi(data, auth.token);
        setLoading(false);

      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }

    
    const editUser = async (id, data) => {
      try {

        setLoading(true);
        await userEditApi(id, data, auth.token)
        setLoading(false);

      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }

    const deleteUser = async(id) => {
      try {
        setLoading(true);
        await userDeleteApi(id, auth.token)
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }

  //PASO 3
  return {
    getMe,
    getUsers,
    loading,
    error,
    users,
    addUser,
    editUser,
    deleteUser
  }
}
